<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="cols" class="d-flex align-center">
        <canvas :id="id" height="350"></canvas>
        <div class="logo"><v-img :src="require(`@/assets/img/${ $vuetify.theme.dark ? 'driblab_white.png': 'driblab_color.png' }`)" max-width="125px"></v-img></div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      barChart: null,
    };
  },
  props:{
    id:{
      type: String,
      required: true
    },
    datasets:{
      type: Array,
      default: () => null,
    },
    xAxisLabels:{
      type: Array,
      default: () => [],
      required: true
    },
    options: {
      type: Object,
      default: () => null,
    },
    cols: {
      type: String,
      default: '12'
    },
    printNumbers: {
      type:Boolean,
      default:false
    },
    noDataText: {
      type: String,
      default: "No Data"
    }
  },
  mounted() {
     this.generateChart();
  },
  watch: {
    id(newId, oldId){
      this.updateChart();
    },
    datasets(newDataSet, oldDataSet){
      this.updateChart();
    },
    xAxisLabels(newLabels,oldLabels){
      this.updateChart();
    }
  },
  methods: {
    generateChart() {
      var ctx = document.getElementById(this.id).getContext("2d");
      var printNumbers = this.printNumbers;
      var noDataText = this.noDataText;
     
      this.barChart = new Chart(ctx, {
          type: 'bar',
          data: {
              title: this.title,
              labels: this.xAxisLabels,
              datasets: this.datasets,
          },
          options: this.options,
          plugins: [{
            afterDraw: function(chart) {
              //Print number over bars
              if(printNumbers){
                chart.config.data.datasets.forEach(dataset => {
                  dataset.data.forEach((value, idx) => {
                    if(value > 0){
                      let x = Object.values(dataset._meta)[0].data[idx]._model.x;
                      let y = Object.values(dataset._meta)[0].data[idx]._model.y - 10;
                      ctx.font = "bold 12pt NeueMontreal";
                      ctx.textAlign = 'center';
                      ctx.fillText(value, x, y);
                    }
                  });
                });
              }
              
              var printChart = false;
              chart.config.data.datasets.forEach(dataset => {
                dataset.data.forEach((value, idx) => {
                    if(value > 0){
                      printChart = true;
                    }
                  });
              });
              
              if (!printChart) {
                // No data is present, all datasets of the chart are empty
                var width = chart.chart.width;
                var height = chart.chart.height
                //Remove chart
                chart.clear();
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = "bold 36px 'NeueMontreal'";
                ctx.fillStyle = "rgba(190, 190, 190, 0.5)";
                ctx.fillText(noDataText, width/2, height/2);
                ctx.restore();
              }
            }
          }]
      });

      //Emit when is loaded
      this.$emit("loaded", this.id);
    },
    updateChart() {
      //Empty labels array
      this.barChart.data.labels = [];
      //Reload labels
      this.xAxisLabels.forEach((xLabel) => {
        this.barChart.data.labels.push(xLabel);
      });

      this.barChart.update();
    },
  },
};
</script>
<style>
  .logo{
    position: absolute;
    top: 86%;
    right: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/BarChart.vue